import { render } from "./MusicEmojis.vue?vue&type=template&id=0821b612"
import script from "./MusicEmojis.vue?vue&type=script&lang=js"
export * from "./MusicEmojis.vue?vue&type=script&lang=js"

import "./MusicEmojis.vue?vue&type=style&index=0&id=0821b612&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__